import React, {useContext, useState} from "react";
import {Button, Col, Form, Input, Row} from "antd";
import {useTranslation} from "react-i18next";
import {UIInputWidgetTimezone} from "../../catalog/ui/input/widget/timezone/ui.input.widget.timezone";
import {RootStoreContext} from "../../../stores/root/root";
import {settingsService} from "../../../services/settings/settings.service";
import {notifications} from "../../../services/notifications/notifications";

export const Settings: React.FC = () => {

    const {authStore: { timezone, setTimezone }} = useContext(RootStoreContext);

    const {t} = useTranslation('translation', {useSuspense: false});
    const [loading, setLoading] = useState<boolean>(false);
    const [form] = Form.useForm();

    return (
        <Form
            form={form}
            layout="vertical"
            initialValues={{timezone}}
            onFinish={() => form
                .validateFields()
                .then(async values => {
                    setLoading(true);
                    try {
                        await settingsService.update(values)
                        setTimezone(values.timezone)
                        notifications.successfully()
                    } finally {
                        setLoading(false)
                    }
                })
            }
        >
            <Row gutter={10} >
                <Col span={12}>
                    <Form.Item
                        name="timezone"
                        label={t("ACCOUNT.SETTINGS.SYSTEM.TIMEZONE")}
                        rules={[{required: true, message: t('FROM.ERROR.PLEASE_ENTER_VALUE')}]}
                    >
                        <UIInputWidgetTimezone loading={loading} />
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Button
                        loading={loading}
                        type={"primary"}
                        onClick={() => form.submit()}
                    >
                        {t("SAVE")}
                    </Button>
                </Col>
            </Row>
        </Form>
    );
}